import { AppState } from 'src/app/core/core.state'
import { ResourceEffects } from 'src/app/shared/resource-effects'

import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'

import { InternalEvent } from './internal-event'
import { internalEventActions } from './internal-event.actions'
import * as fromInternalEvent from './internal-event.reducer'
import { InternalEventService } from './internal-event.service'
import { persistentUserRoleActions } from '../role/user-role/persistent-user-role/persistent-user-role.actions'
import { switchMap, take, tap } from 'rxjs/operators'
import { of } from 'rxjs'
import { persistentUserRoleSelectors } from '../role/user-role/persistent-user-role/persistent-user-role.selector'

@Injectable()
export class InternalEventEffects extends ResourceEffects<InternalEvent> {
  constructor(
    public actions$: Actions,
    public store: Store<AppState>,
    public internalEventService: InternalEventService
  ) {
    super(
      fromInternalEvent.FEATURE_NAME,
      internalEventService,
      internalEventActions,
      actions$
    )
  }
  onSetSelectedUserRole = createEffect(
    () =>
      this.actions$.pipe(
        ofType(persistentUserRoleActions.setSelectedUserRole),
        tap((action) => {
          let userRole:any
          this.store.select(persistentUserRoleSelectors.selectSelectedUserRole).pipe(
            take(1)
            ).subscribe((user)=>{
              userRole=user
            })
            userRole&&this.store.dispatch(internalEventActions.resetState())})
      ),
    { dispatch: false }
  )
}
